import { formatDateTime } from '@efdigital/ll-addon-coaching/utils/coaching-sessions/session-dates';
import type { CoachingSession } from '@efdigital/ll-addon-data';
import { displayValue } from '@efdigital/ll-admin-v2/utils/display-value';
import type { TOC } from '@ember/component/template-only';

function toDate(date: string): Date {
  return new Date(date);
}

export default <template>
  <div class="card rounded-4" ...attributes>
    <h3 class="card-header h5 py-3">Booking and calendar</h3>
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-sm-4 col-lg-3 text-body-secondary">
          Booking pending at
        </div>
        <div class="col-sm-8 col-lg-9">
          {{#if @coachingSession.bookingPendingAt}}
            {{formatDateTime (toDate @coachingSession.bookingPendingAt)}}
          {{else}}
            —
          {{/if}}
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-sm-4 col-lg-3 text-body-secondary">
          Booking failure stage
        </div>
        <div class="col-sm-8 col-lg-9">
          {{displayValue @coachingSession.bookingFailureStage}}
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-sm-4 col-lg-3 text-body-secondary">
          Booking failure message
        </div>
        <div class="col-sm-8 col-lg-9">
          {{displayValue @coachingSession.bookingFailureMessage}}
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-sm-4 col-lg-3 text-body-secondary">
          Cancellation window (hours)
        </div>
        <div class="col-sm-8 col-lg-9">
          {{displayValue @coachingSession.cancellationWindowHours}}
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-sm-4 col-lg-3 text-body-secondary">
          Cronofy event ID
        </div>
        <div class="col-sm-8 col-lg-9">
          {{displayValue @coachingSession.cronofyEventId}}
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 col-lg-3 text-body-secondary">
          Idempotency key
        </div>
        <div class="col-sm-8 col-lg-9">
          {{displayValue @coachingSession.idempotencyKey}}
        </div>
      </div>
    </div>
  </div>
</template> satisfies TOC<{
  Args: {
    coachingSession: CoachingSession;
  };
  Element: HTMLDivElement;
}>;
